import Vue from 'baseVue';
import {mixin} from 'lvgs-vue-modules';
import formElements from 'formElementsLp1';
import fetchMaster from 'fetchMasterLp1';
import validateStore from 'validateStore';
import googleClientIdComponent from 'googleClientIdComponent';
import _ from 'lodash';

/** Set Mixin */
Vue.mixin(fetchMaster);
Vue.mixin(mixin.displayByOtherField);
// 既存のvalidateアクションを上書くために削除
Vue.options.store._actions.validate = null;
Vue.options.store.registerModule('validateStore', validateStore);

/** Set Custom Option */
_.forEach(formElements, (element, name) => {
  Vue.component(name, element);
});
Vue.component('v-google-cid', googleClientIdComponent);

export default Vue;
